module.exports = __webpack_public_path__ + "img/2_x8.fec17cef.png";